"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Product = void 0;

var react_1 = __importDefault(require("react"));

var elements_1 = require("../../elements");

var images_1 = require("../../elements/images");

var typings_1 = require("../../typings");

var utils_1 = require("../../utils");

var Product = function Product(_a) {
  var title = _a.title,
      content = _a.content,
      src = _a.src,
      alt = _a.alt,
      caption = _a.caption,
      _b = _a.orientation,
      orientation = _b === void 0 ? typings_1.Orientation.right : _b,
      theme = _a.theme,
      elementId = _a.elementId;
  var contentBlock = react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(elements_1.TitleAbstract, {
    theme: theme
  }, title), react_1["default"].createElement(elements_1.Hruler, {
    theme: theme
  }), react_1["default"].createElement(elements_1.TextRegular, {
    theme: theme
  }, content));
  var imageBlock = react_1["default"].createElement(images_1.Image, {
    src: src,
    alt: alt,
    caption: caption
  });
  var style = "" + (theme ? theme.body.backgroundColor : 'bg-gray-100');
  var isImageIsLeft = orientation === typings_1.Orientation.left;
  return react_1["default"].createElement(react_1["default"].Fragment, null, (0, utils_1.isMobileView)(640) ? react_1["default"].createElement("div", {
    className: "w-full"
  }, contentBlock) : react_1["default"].createElement("div", {
    className: "flex flex-row items-center " + style,
    id: elementId
  }, react_1["default"].createElement("div", {
    className: (isImageIsLeft ? 'w-2/5' : 'w-3/5') + " mr-8"
  }, isImageIsLeft ? imageBlock : contentBlock), react_1["default"].createElement("div", {
    className: (isImageIsLeft ? 'w-3/5' : 'w-2/5') + " ml-8"
  }, isImageIsLeft ? contentBlock : imageBlock)));
};

exports.Product = Product;